function encodeUtf8(e) {
  let r2 = []
  for (let a = encodeURIComponent(e), c = 0;c < a.length; c++) {
    const d = a.charAt(c);
    if (d === "%") {
      const s = Number.parseInt(a.charAt(c + 1) + a.charAt(c + 2), 16);
      r2.push(s), c += 2;
    } else
      r2.push(d.charCodeAt(0));
  }
  return r2;
}
var c = [
  "Z",
  "m",
  "s",
  "e",
  "r",
  "b",
  "B",
  "o",
  "H",
  "Q",
  "t",
  "N",
  "P",
  "+",
  "w",
  "O",
  "c",
  "z",
  "a",
  "/",
  "L",
  "p",
  "n",
  "g",
  "G",
  "8",
  "y",
  "J",
  "q",
  "4",
  "2",
  "K",
  "W",
  "Y",
  "j",
  "0",
  "D",
  "S",
  "f",
  "d",
  "i",
  "k",
  "x",
  "3",
  "V",
  "T",
  "1",
  "6",
  "I",
  "l",
  "U",
  "A",
  "F",
  "M",
  "9",
  "7",
  "h",
  "E",
  "C",
  "v",
  "u",
  "R",
  "X",
  "5"
];
function tripletToBase64(e) {
  return c[e >> 18 & 63] + c[e >> 12 & 63] + c[e >> 6 & 63] + c[63 & e];
}
function encodeChunk(e, a, r2) {
  for (var c2, d = [], s = a;s < r2; s += 3)
    c2 = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), d.push(tripletToBase64(c2));
  return d.join("");
}
function b64Encode(e) {
  for (var a, r2 = e.length, d = r2 % 3, s = [], f = 16383, u = 0, l = r2 - d;u < l; u += f)
    s.push(encodeChunk(e, u, u + f > l ? l : u + f));
  return d === 1 ? (a = e[r2 - 1], s.push(c[a >> 2] + c[a << 4 & 63] + "==")) : d === 2 && (a = (e[r2 - 2] << 8) + e[r2 - 1], s.push(c[a >> 10] + c[a >> 4 & 63] + c[a << 2 & 63] + "=")), s.join("");
}
function encode_mnsv2(mnsv2, type, platform, req_type) {
  const f = {
    x0: "4.2.8",
    x1: type,
    x2: platform,
    x3: mnsv2,
    x4: req_type
  };
  return "XYS_" + b64Encode(encodeUtf8(JSON.stringify(f)));
}
module.exports = encode_mnsv2
